import {
    FETCH_INITIAL_TEMPLATES_DATA_REQUEST,
      FETCH_INITIAL_TEMPLATES_DATA_SUCCESS,
      FETCH_INITIAL_TEMPLATES_DATA_FAILURE,
    } from "./FetchInitialTemplateDataTypes";
    import api from "../../utils/Api";
    
    export const fetchInitialTemplatesDataRequest = () => {
      return {
        type: FETCH_INITIAL_TEMPLATES_DATA_REQUEST,
      };
    };
    
    export const fetchInitialTemplatesDataSuccess = (initialTemplatesData) => {
      return {
        type: FETCH_INITIAL_TEMPLATES_DATA_SUCCESS,
        payload: initialTemplatesData,
      };
    };
    
    export const fetchInitialTemplatesDataFailure = (error) => {
      return {
        type: FETCH_INITIAL_TEMPLATES_DATA_FAILURE,
        payload: error,
      };
    };
    
    export const fetchInitialTemplatesData = () => {
      
      const headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      };
      let url = "template/dropdown/fetch";
    
      
      return async (dispatch) => {
        dispatch(fetchInitialTemplatesDataRequest);
        try {
          const response = await api.get(url,
            {
              headers: headers,
            }
          );
          const initialTemplatesData = response.data.data;
          dispatch(fetchInitialTemplatesDataSuccess(initialTemplatesData));
        } catch (error) {
          console.log("Redux error - ", error.response);
          const errorMsg = error.message;
          dispatch(fetchInitialTemplatesDataFailure(errorMsg));
        }
      };
    };
    